import { lazy } from 'react';
import * as routePath from '../route-path';
import { staffRoutes } from './staff-routes';
import { userRoutes } from './user-routes';
import { templateRoutes } from './template-routes';
import { codeRoutes } from './code-routes';
import { allocationRoutes } from './allocation-routes';
import { campaignRoutes } from './campaign-routes';
import { partnerProgramRoutes } from './partner-program-routes';
const ExampleComponentsPage = lazy(() =>
  import('components/Pages/ExampleComponents')
);

const routes = [
  ...staffRoutes,
  ...userRoutes,
  ...templateRoutes,
  ...codeRoutes,
  ...allocationRoutes,
  ...campaignRoutes,
  ...partnerProgramRoutes,
  {
    path: routePath.COMPONENTS,
    component: ExampleComponentsPage,
    exact: true,
    hide: ['local', 'development'].indexOf(process.env.REACT_APP_NODE_ENV) < 0,
  },
];

export default routes;
